"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.infer = exports.Inferred = void 0;
const check_1 = require("../check");
const closure_1 = require("../closure");
const Cores = __importStar(require("../core"));
const ctx_1 = require("../ctx");
const Errors = __importStar(require("../errors"));
const evaluate_1 = require("../evaluate");
const Exps = __importStar(require("../exp"));
const infer_1 = require("../infer");
const insert_1 = require("../insert");
const readback_1 = require("../readback");
const Values = __importStar(require("../value"));
function Inferred(type, core) {
    return {
        type,
        core,
    };
}
exports.Inferred = Inferred;
function infer(mod, ctx, exp) {
    switch (exp["@kind"]) {
        case "Var": {
            const type = (0, ctx_1.ctxLookupType)(ctx, exp.name);
            if (type !== undefined) {
                return Inferred(type, Cores.Var(exp.name));
            }
            throw new Errors.ElaborationError(`[infer] undefined name: ${exp.name}, when inferred Var`, { span: exp.span });
        }
        case "Pi": {
            const argTypeCore = (0, check_1.checkType)(mod, ctx, exp.argType);
            const argTypeValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), argTypeCore);
            ctx = (0, ctx_1.CtxCons)(exp.name, argTypeValue, ctx);
            const retTypeCore = (0, check_1.checkType)(mod, ctx, exp.retType);
            return Inferred(Values.Type(), Cores.Pi(exp.name, argTypeCore, retTypeCore));
        }
        case "PiImplicit": {
            const argTypeCore = (0, check_1.checkType)(mod, ctx, exp.argType);
            const argTypeValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), argTypeCore);
            ctx = (0, ctx_1.CtxCons)(exp.name, argTypeValue, ctx);
            const retTypeCore = (0, check_1.checkType)(mod, ctx, exp.retType);
            return Inferred(Values.Type(), Cores.PiImplicit(exp.name, argTypeCore, retTypeCore));
        }
        case "PiUnfolded": {
            return infer(mod, ctx, Exps.foldPi(exp.bindings, exp.retType));
        }
        case "FnAnnotated": {
            const argTypeCore = (0, check_1.checkType)(mod, ctx, exp.argType);
            const argTypeValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), argTypeCore);
            ctx = (0, ctx_1.CtxCons)(exp.name, argTypeValue, ctx);
            const retInferred = infer(mod, ctx, exp.ret);
            const retTypeCore = (0, readback_1.readbackType)(mod, ctx, retInferred.type);
            const retTypeClosure = (0, closure_1.ClosureSimple)((0, ctx_1.ctxToEnv)(ctx), exp.name, retTypeCore);
            return Inferred(Values.Pi(argTypeValue, retTypeClosure), Cores.Fn(exp.name, retInferred.core));
        }
        case "FnImplicitAnnotated": {
            const argTypeCore = (0, check_1.checkType)(mod, ctx, exp.argType);
            const argTypeValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), argTypeCore);
            ctx = (0, ctx_1.CtxCons)(exp.name, argTypeValue, ctx);
            const retInferred = infer(mod, ctx, exp.ret);
            const retTypeCore = (0, readback_1.readbackType)(mod, ctx, retInferred.type);
            const retTypeClosure = (0, closure_1.ClosureSimple)((0, ctx_1.ctxToEnv)(ctx), exp.name, retTypeCore);
            return Inferred(Values.PiImplicit(argTypeValue, retTypeClosure), Cores.FnImplicit(exp.name, retInferred.core));
        }
        case "FnUnfolded": {
            return infer(mod, ctx, Exps.foldFn(exp.bindings, exp.ret));
        }
        case "FnUnfoldedWithRetType": {
            return infer(mod, ctx, Exps.foldFnWithRetType(exp.bindings, exp.retType, exp.ret));
        }
        case "Ap": {
            try {
                const { target, args } = Exps.unfoldAp(exp);
                const inferred = infer(mod, ctx, target);
                if (inferred.type["@kind"] === "PiImplicit") {
                    return (0, insert_1.insertDuringInfer)(mod, ctx, inferred, args);
                }
            }
            catch (error) {
                if (error instanceof Errors.UnificationError) {
                    throw new Errors.ElaborationError([
                        `[infer] meet UnificationError, when inferring Ap`,
                        ...error.trace,
                        error.message,
                    ].join("\n"), { span: exp.span });
                }
                throw error;
            }
            const inferred = infer(mod, ctx, exp.target);
            const fulfilled = (0, infer_1.inferFulfillingClazz)(mod, ctx, inferred, exp.arg);
            if (fulfilled !== undefined)
                return fulfilled;
            Values.assertTypeInCtx(mod, ctx, inferred.type, "Pi");
            const argCore = (0, check_1.check)(mod, ctx, exp.arg, inferred.type.argType);
            const argValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), argCore);
            return Inferred((0, closure_1.closureApply)(inferred.type.retTypeClosure, argValue), Cores.Ap(inferred.core, argCore));
        }
        case "ApImplicit": {
            const inferred = infer(mod, ctx, exp.target);
            Values.assertTypeInCtx(mod, ctx, inferred.type, "PiImplicit");
            const argCore = (0, check_1.check)(mod, ctx, exp.arg, inferred.type.argType);
            const argValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), argCore);
            return Inferred((0, closure_1.closureApply)(inferred.type.retTypeClosure, argValue), Cores.ApImplicit(inferred.core, argCore));
        }
        case "ApUnfolded": {
            return infer(mod, ctx, Exps.foldAp(exp.target, exp.args));
        }
        case "Sigma": {
            const carTypeCore = (0, check_1.checkType)(mod, ctx, exp.carType);
            const carTypeValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), carTypeCore);
            ctx = (0, ctx_1.CtxCons)(exp.name, carTypeValue, ctx);
            const cdrTypeCore = (0, check_1.checkType)(mod, ctx, exp.cdrType);
            return Inferred(Values.Type(), Cores.Sigma(exp.name, carTypeCore, cdrTypeCore));
        }
        case "SigmaUnfolded": {
            return infer(mod, ctx, Exps.foldSigma(exp.bindings, exp.cdrType));
        }
        case "Cons": {
            const carInferred = infer(mod, ctx, exp.car);
            const cdrInferred = infer(mod, ctx, exp.cdr);
            const cdrTypeClosure = (0, closure_1.ClosureNative)("_", () => cdrInferred.type);
            return Inferred(Values.Sigma(carInferred.type, cdrTypeClosure), Cores.Cons(carInferred.core, cdrInferred.core));
        }
        case "Quote": {
            return Inferred(Values.String(), Cores.Quote(exp.data));
        }
        case "ClazzNull":
        case "ClazzCons":
        case "ClazzFulfilled": {
            return Inferred(Values.Type(), (0, check_1.checkClazz)(mod, ctx, exp));
        }
        case "ClazzUnfolded": {
            return infer(mod, ctx, Exps.foldClazz(exp.bindings, exp.name));
        }
        case "Objekt": {
            let clazz = Values.ClazzNull();
            const properties = {};
            for (const [name, property] of Object.entries(exp.properties).reverse()) {
                const inferred = infer(mod, ctx, property);
                const value = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), inferred.core);
                clazz = Values.ClazzFulfilled(name, inferred.type, value, clazz);
                properties[name] = inferred.core;
            }
            return Inferred(clazz, Cores.Objekt(properties));
        }
        case "ObjektUnfolded": {
            return infer(mod, ctx, Exps.Objekt(Exps.prepareProperties(mod, ctx, exp.properties)));
        }
        case "Dot": {
            const inferred = infer(mod, ctx, exp.target);
            const targetValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), inferred.core);
            Values.assertClazzInCtx(mod, ctx, inferred.type);
            const propertyType = Values.clazzLookupPropertyType(targetValue, inferred.type, exp.name);
            if (propertyType === undefined) {
                throw new Errors.ElaborationError(`[infer] undefined property: ${name}, when inferring Dot`, { span: exp.span });
            }
            return Inferred(propertyType, Cores.Dot(inferred.core, exp.name));
        }
        case "NewUnfolded": {
            return infer(mod, ctx, Exps.New(exp.name, Exps.prepareProperties(mod, ctx, exp.properties)));
        }
        case "New": {
            const clazz = (0, ctx_1.ctxLookupValue)(ctx, exp.name);
            if (clazz === undefined) {
                throw new Errors.ElaborationError(`[infer] undefined class: ${exp.name}, when inferring New`, { span: exp.span });
            }
            Values.assertClazzInCtx(mod, ctx, clazz);
            const inferred = (0, infer_1.inferProperties)(mod, ctx, exp.properties, clazz);
            const names = Object.keys(inferred.properties);
            const extra = (0, infer_1.inferExtraProperties)(mod, ctx, exp.properties, names);
            /**
               We add the inferred `extra.clazz` to the return value,
               because the body of the `New` might have extra properties,
               thus more specific than the given type.
            **/
            return Inferred(Values.clazzFulfilledPrepend(inferred.clazz, extra.clazz), Cores.Objekt(Object.assign(Object.assign({}, inferred.properties), extra.properties)));
        }
        case "NewAp": {
            const clazz = (0, ctx_1.ctxLookupValue)(ctx, exp.name);
            if (clazz === undefined) {
                throw new Errors.ElaborationError(`[infer] undefined class: ${exp.name}, when inferring NewAp`, { span: exp.span });
            }
            Values.assertClazzInCtx(mod, ctx, clazz);
            const properties = (0, infer_1.inferNewArgs)(mod, ctx, exp.args, clazz);
            return Inferred(clazz, Cores.Objekt(properties));
        }
        case "SequenceUnfolded": {
            return infer(mod, ctx, Exps.foldSequence(exp.bindings, exp.ret));
        }
        case "SequenceLet": {
            const inferred = infer(mod, ctx, exp.exp);
            const value = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), inferred.core);
            ctx = (0, ctx_1.CtxFulfilled)(exp.name, inferred.type, value, ctx);
            const retInferred = infer(mod, ctx, exp.ret);
            return Inferred(retInferred.type, Cores.Ap(Cores.Fn(exp.name, retInferred.core), inferred.core));
        }
        case "SequenceLetThe": {
            const typeCore = (0, check_1.checkType)(mod, ctx, exp.type);
            const type = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), typeCore);
            const core = (0, check_1.check)(mod, ctx, exp.exp, type);
            const value = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), core);
            ctx = (0, ctx_1.CtxFulfilled)(exp.name, type, value, ctx);
            const retInferred = infer(mod, ctx, exp.ret);
            return Inferred(retInferred.type, Cores.Ap(Cores.Fn(exp.name, retInferred.core), core));
        }
        case "SequenceCheck": {
            const typeCore = (0, check_1.checkType)(mod, ctx, exp.type);
            const type = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), typeCore);
            (0, check_1.check)(mod, ctx, exp.exp, type);
            return infer(mod, ctx, exp.ret);
        }
        case "MacroEmbedded": {
            return infer(mod, ctx, exp.macro.expand());
        }
        default: {
            throw new Errors.ElaborationError(`[infer] is not implemented for: ${exp["@kind"]}`, { span: exp.span });
        }
    }
}
exports.infer = infer;
//# sourceMappingURL=infer.js.map